import { IngredientType } from '@libs/trip-planner-interfaces';
import type {
  IngredientId,
  SelectedTicketInfo,
} from '@libs/trip-planner-interfaces';

import { BaseIngredient } from './baseIngredient';

export class ActivityIngredient extends BaseIngredient<IngredientType.Activity> {
  public offset = 0;
  public tickets: SelectedTicketInfo[] = [];

  constructor(public code: string, public parentIngredientId: IngredientId) {
    super(IngredientType.Activity);
  }

  public isIngredientCorrect(): boolean {
    return true;
  }
}
